export default {"src":"/_next/static/media/BITGET.e6ac5ee5.svg","height":29,"width":84,"blurWidth":0,"blurHeight":0};